"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleLineChart = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var AP = __importStar(require("fp-ts/Apply"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var recharts_1 = require("recharts");
var utils_1 = require("../SimpleBarChart/utils");
var axisTickBuilder_1 = require("../axisTickBuilder");
require("./simpleLineChart.css");
var SimpleLineChart = function (props) {
    var GREY_STROKE = '#bdbdbd';
    var VERY_LIGHT_GREY_STROKE = '#f5f5f5';
    function renderLineStrokeColor(c) {
        switch (c) {
            case 'lime-green':
                return '#c1cf55';
            case 'lighter-blue':
                return '#14aff0';
            case 'strong-light-blue':
                return '#0e83cd';
            case 'strong-yellow':
                return '#ff9902';
            case 'very-light-orange':
                return '#ffd27a';
        }
    }
    function renderLines(theme) {
        return (0, utils_1.buildArrayFromObjectKeys)(theme).map(function (tt) {
            return (0, function_1.pipe)(O.fromNullable(props.theme[tt]), (0, Option_1.map)(function (t) { return ((0, jsx_runtime_1.jsx)(recharts_1.Line, { type: t.lineType, dataKey: tt, strokeWidth: 2, stroke: renderLineStrokeColor(t.color) }, "line_".concat(tt))); }), O.toNullable);
        });
    }
    function renderReferenceLines(theme) {
        return (0, utils_1.buildArrayFromObjectKeys)(theme).map(function (tt) {
            return (0, function_1.pipe)(AP.sequenceT(O.Applicative)((0, function_1.pipe)(O.fromNullable(props.theme[tt])), (0, function_1.pipe)(O.fromNullable(props.theme[tt]), O.chainNullableK(function (t) { return t.yReference; }))), (0, Option_1.map)(function (_a) {
                var t = _a[0], r = _a[1];
                return ((0, jsx_runtime_1.jsx)(recharts_1.ReferenceLine, { y: r, stroke: renderLineStrokeColor(t.color), strokeDasharray: "3 3" }, "reference_line_".concat(tt)));
            }), O.toNullable);
        });
    }
    return ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ width: "100%", height: props.height, className: "simple-line-chart" }, { children: (0, jsx_runtime_1.jsxs)(recharts_1.LineChart, __assign({ data: props.data, margin: {
                top: 30,
                right: 30,
                left: 0,
                bottom: 0,
            } }, { children: [(0, jsx_runtime_1.jsx)(recharts_1.XAxis, { stroke: GREY_STROKE, tickMargin: 10, tickSize: 0, axisLine: false, tick: axisTickBuilder_1.renderXAxisTick, dataKey: "xLabel" }), (0, jsx_runtime_1.jsx)(recharts_1.YAxis, { stroke: GREY_STROKE, tickMargin: 5, tickSize: 0, tick: axisTickBuilder_1.renderYAxisTick, ticks: props.yTicks, axisLine: false }), (0, jsx_runtime_1.jsx)(recharts_1.CartesianGrid, { stroke: VERY_LIGHT_GREY_STROKE, vertical: false }), (0, jsx_runtime_1.jsx)(recharts_1.Tooltip, __assign({}, (props.customTooltip ? { content: props.customTooltip } : {}))), renderLines(props.theme), renderReferenceLines(props.theme)] })) })));
};
exports.SimpleLineChart = SimpleLineChart;
//# sourceMappingURL=SimpleLineChart.js.map